import { Component } from "@angular/core";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "app-failed",
  templateUrl: "./login-failed.component.html",
  styleUrls: ["./login-failed.component.css"],
  standalone: false,
})
export class LoginFailedComponent {
  constructor(public authService: AuthService) {}
}
